import { parseISO } from 'date-fns';
import * as React from 'react';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../../../sanity';
import { DateDisplay } from '../../../../../../../../../../../../../DateDisplay';

export const useReleaseDate = (dateString?: string | undefined) => {
  const releaseDate = React.useMemo(() => (dateString != null ? parseISO(dateString) : undefined), [dateString]);
  return releaseDate;
};

export const ReleaseDateDisplay = () => {
  const {
    data,
  } = useSanityNewsByUrlId();

  const releaseDate = useReleaseDate(data?.publishDate);
  if (releaseDate == null) {
    return null;
  }
  return (
    <DateDisplay
      date={releaseDate}
      format="dd/MM/yyyy — HH:mm"
    />
  );
};
